module.exports = __webpack_public_path__ + "img/24.4b022d94.jpg";